module.exports = __webpack_public_path__ + "img/intro_uk.412210f0.svg";